<template>
	<div v-show="show" @click="close()">
		<div class="chat-emotion" :style="{ 'left': x + 'px', 'top': y + 'px' }" @click.stop>
			<el-scrollbar class="emotion-scroll">
				<div class="emotion-section">
					<template v-if="isSearchTab">
						<div class="search-box">
							<el-input ref="searchInput" size="small" v-model.trim="searchText" placeholder="输入表情名称搜索"
								clearable @input="onSearchInput" @clear="onSearchClear">
								<template #suffix>
									<i class="el-icon-search"></i>
								</template>
							</el-input>
						</div>
						<div class="sticker-items" v-if="searchName && searchResults.length">
							<div class="sticker-item" v-for="sticker in searchResults" :key="`search-${sticker.id}`"
								@click="onClickSticker(sticker)" @mouseenter="onPreviewSticker(sticker, $event)"
								@mouseleave="hidePreview">
								<img :src="sticker.thumbUrl || sticker.imageUrl" :alt="sticker.name">
								<div class="sticker-name" :title="sticker.name">{{ sticker.name }}</div>
							</div>
						</div>
						<div class="sticker-empty" v-else-if="searchLoading">搜索中...</div>
						<div class="sticker-empty" v-else-if="searchName">未找到相关表情</div>
						<div class="sticker-empty" v-else>请输入表情名称进行搜索</div>
					</template>
					<template v-else-if="isDefaultTab">
						<div class="emotion-items">
							<div class="emotion-item" v-for="(emoText, i) in defaultEmotions" :key="`default-${i}`"
								@click="onClickEmo(emoText)">
								<img :src="emojiUrl(emoText)" :alt="emoText" class="emoji-large">
							</div>
						</div>
					</template>
					<template v-else-if="isCustomTab">
						<div class="sticker-items">
							<div class="sticker-item upload-item" @click.stop>
								<file-upload :action="'/image/upload?thumbSize=20'" :maxSize="5 * 1024 * 1024"
									:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
									:isPermanent="true" :showLoading="true" @success="onUploadSuccess">
									<div class="upload-btn">
										<i class="el-icon-plus"></i>
									</div>
								</file-upload>
							</div>
							<div class="sticker-item" v-for="sticker in stickerList" :key="sticker.id"
								@click="onClickCustomSticker(sticker)"
								@contextmenu.prevent="onCustomStickerContextMenu(sticker, $event)"
								@mouseenter="onPreviewSticker(sticker, $event)" @mouseleave="hidePreview">
								<img :src="sticker.thumbUrl || sticker.imageUrl" :alt="sticker.name">
							</div>
						</div>
						<div class="sticker-empty" v-if="!stickerList.length && !loadingCustomStickers">暂无自定义表情，点击上方按钮添加
						</div>
						<div class="sticker-empty" v-if="loadingCustomStickers">加载中...</div>
					</template>
					<template v-else>
						<div class="sticker-items" v-if="stickerList.length">
							<div class="sticker-item" v-for="sticker in stickerList" :key="sticker.id"
								@click="onClickSticker(sticker)" @mouseenter="onPreviewSticker(sticker, $event)"
								@mouseleave="hidePreview">
								<img :src="sticker.thumbUrl || sticker.imageUrl" :alt="sticker.name">
								<div class="sticker-name" :title="sticker.name">{{ sticker.name }}</div>
							</div>
						</div>
						<div class="sticker-empty" v-else-if="!loadingStickers">暂无表情</div>
						<div class="sticker-empty" v-else>加载中...</div>
					</template>
				</div>
			</el-scrollbar>
			<div class="album-bar-wrapper" v-if="albumBarItems.length">
				<button v-if="isNeedPage" class="album-arrow prev" type="button" @click.stop="prevAlbumPage"
					:disabled="!canPrev">
					<i class="el-icon-arrow-left"></i>
				</button>
				<div class="album-bar">
					<div class="album-item" v-for="item in displayAlbumItems" :key="item.id"
						:class="{ active: item.id === selectedAlbumId }" @click.stop="onSelectAlbum(item)"
						:title="item.name">
						<span v-if="item.isSearch" class="album-item-icon">
							<i class="icon iconfont icon-search"></i>
						</span>
						<span v-else-if="item.isDefault" class="album-item-icon">
							<i class="icon iconfont icon-emoji"></i>
						</span>
						<span v-else-if="item.isCustom" class="album-item-icon">
							<i class="icon iconfont icon-love"></i>
						</span>
						<img v-else :src="item.logoUrl" :alt="item.name">
					</div>
				</div>
				<button v-if="isNeedPage" class="album-arrow next" type="button" @click.stop="nextAlbumPage"
					:disabled="!canNext">
					<i class="el-icon-arrow-right"></i>
				</button>
			</div>
			<div class="preview-box" v-if="preview.visible" :style="preview.style">
				<img :src="preview.url" alt="preview">
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectCustomMenu"></right-menu>
	</div>
</template>

<script>
import RightMenu from '../common/RightMenu.vue';
import FileUpload from '../common/FileUpload.vue';

export default {
	components: {
		RightMenu,
		FileUpload
	},
	name: "emotion",
	data() {
		return {
			show: false,
			pos: {
				x: 0,
				y: 0
			},
			albumList: [],
			selectedAlbumId: 'default',
			albumPage: 0,
			albumsPerPage: 7,
			stickerList: [],
			stickerCache: {},
			loadingAlbums: false,
			loadingStickers: false,
			preview: {
				visible: false,
				url: '',
				style: {
					left: '0px',
					top: '0px'
				}
			},
			searchText: '',
			searchResults: [],
			searchLoading: false,
			searchTimer: null,
			latestSearchName: '',
			searchCache: {},
			customStickerList: [],
			customStickerCache: null,
			loadingCustomStickers: false,
			selectedCustomSticker: null
		}
	},
	created() {
		this.loadAlbums();
	},
	beforeDestroy() {
		this.clearSearchTimer();
	},
	methods: {
		onClickEmo(emoText) {
			let emotion = `#${emoText};`
			this.$emit('emotion', emotion)
			this.close();
		},
		onClickCustomSticker(custom) {
			const sticker = {
				id: custom.stickerId,
				albumId: custom.albumId,
				name: custom.name,
				imageUrl: custom.imageUrl,
				thumbUrl: custom.thumbUrl,
				width: custom.width,
				height: custom.height
			}
			this.onClickSticker(sticker);
		},
		onClickSticker(sticker) {
			this.$emit('emotion', { type: 'sticker', data: sticker });
			this.close();
		},
		open(pos) {
			this.pos = pos;
			this.show = true;
		},
		close() {
			this.show = false;
		},
		loadAlbums() {
			this.loadingAlbums = true;
			this.fetchStickerAlbums().then((albums = []) => {
				this.albumList = albums;
			}).finally(() => {
				this.loadingAlbums = false;
			});
		},
		onSelectAlbum(album) {
			if (album.isSearch) {
				this.selectedAlbumId = 'search';
				this.$nextTick(() => {
					if (this.$refs.searchInput && this.$refs.searchInput.focus) {
						this.$refs.searchInput.focus();
					}
					if (this.searchName) {
						this.debounceSearch(this.searchName);
					}
				});
			}
			else if (album.isDefault) {
				this.selectDefault();
			} else if (album.isCustom) {
				this.selectedAlbumId = 'custom';
				this.loadCustomStickers();
			} else {
				this.selectedAlbumId = album.id;
				this.loadStickers(album.id);
			}

		},
		selectDefault() {
			this.selectedAlbumId = 'default';
			this.stickerList = [];
		},
		prevAlbumPage() {
			if (this.canPrev) {
				this.albumPage -= 1;
			}
		},
		nextAlbumPage() {
			if (this.canNext) {
				this.albumPage += 1;
			}
		},
		loadStickers(albumId) {
			if (this.stickerCache[albumId]) {
				this.stickerList = this.stickerCache[albumId];
				return;
			}
			this.loadingStickers = true;
			this.fetchStickersByAlbum(albumId).then((stickers = []) => {
				this.stickerCache[albumId] = stickers;
				if (this.selectedAlbumId === albumId) {
					this.stickerList = stickers;
				}
			}).finally(() => {
				this.loadingStickers = false;
			});
		},
		onSearchInput() {
			const name = this.searchName;
			if (!name) {
				this.clearSearchResults();
				return;
			}
			this.debounceSearch(name);
		},
		onSearchClear() {
			this.searchText = '';
			this.clearSearchResults();
			this.$nextTick(() => {
				if (this.$refs.searchInput && this.$refs.searchInput.focus) {
					this.$refs.searchInput.focus();
				}
			});
		},
		debounceSearch(name) {
			this.clearSearchTimer();
			this.searchTimer = setTimeout(() => {
				this.performSearch(name);
			}, 300);
		},
		clearSearchTimer() {
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
				this.searchTimer = null;
			}
		},
		performSearch(name) {
			if (this.searchCache[name]) {
				this.searchResults = this.searchCache[name];
				this.searchLoading = false;
				return;
			}
			this.searchLoading = true;
			this.searchResults = [];
			this.latestSearchName = name;
			this.searchStickers(name).then(stickers => {
				if (this.latestSearchName !== name) {
					return;
				}
				this.searchCache[name] = stickers;
				this.searchResults = stickers;
			}).catch(() => {
				if (this.latestSearchName !== name) {
					return;
				}
				this.searchResults = [];
			}).finally(() => {
				if (this.latestSearchName === name) {
					this.searchLoading = false;
				}
			});
		},
		clearSearchResults() {
			this.clearSearchTimer();
			this.searchResults = [];
			this.searchLoading = false;
			this.latestSearchName = '';
		},
		onPreviewSticker(sticker, event) {
			const url = sticker.imageUrl || sticker.thumbUrl;
			this.showPreview(url, event);
		},
		showPreview(url, event) {
			const container = event.currentTarget.closest('.chat-emotion');
			const containerRect = container.getBoundingClientRect();
			const targetRect = event.currentTarget.getBoundingClientRect();
			let left = targetRect.right - containerRect.left + 10;
			let top = targetRect.top - containerRect.top - 10;
			if (left + 120 > containerRect.width) {
				left = targetRect.left - containerRect.left - 120 - 10;
			}
			if (top + 120 > containerRect.height) {
				top = containerRect.height - 130;
			}
			if (top < 0) {
				top = 0;
			}
			this.preview = {
				visible: true,
				url,
				style: {
					left: `${left}px`,
					top: `${top}px`
				}
			};
		},
		hidePreview() {
			this.preview.visible = false;
		},
		emojiUrl(emoText) {
			return this.$emo.textToUrl(`#${emoText};`);
		},
		fetchStickerAlbums() {
			return this.$http({
				url: '/sticker/albums',
				method: 'get'
			});
		},
		fetchStickersByAlbum(albumId) {
			return this.$http({
				url: `/sticker/stickers/${albumId}`,
				method: 'get'
			});
		},
		searchStickers(name) {
			return this.$http({
				url: '/sticker/stickers/search',
				method: 'get',
				params: {
					name
				}
			});
		},
		loadCustomStickers() {
			if (this.customStickerCache) {
				this.stickerList = this.customStickerCache;
				return;
			}
			this.loadingCustomStickers = true;
			this.fetchCustomStickers().then((stickers = []) => {
				this.customStickerCache = stickers;
				if (this.selectedAlbumId === 'custom') {
					this.stickerList = stickers;
				}
			}).finally(() => {
				this.loadingCustomStickers = false;
			});
		},
		refreshCustomStickers() {
			// 清除缓存并重新加载自定义表情
			this.customStickerCache = null;
			if (this.selectedAlbumId === 'custom') {
				this.loadCustomStickers();
			}
		},
		fetchCustomStickers() {
			return this.$http({
				url: '/sticker/custom/list',
				method: 'get'
			});
		},
		onCustomStickerContextMenu(sticker, event) {
			if (this.selectedAlbumId !== 'custom') {
				return;
			}
			this.selectedCustomSticker = sticker;
			const menuItems = [
				{
					key: 'TOP',
					name: '置顶'
				},
				{
					key: 'DELETE',
					name: '删除',
					danger: true
				}
			];
			this.$refs.rightMenu.open({
				x: event.clientX,
				y: event.clientY
			}, menuItems);
		},
		onSelectCustomMenu(item) {
			if (!this.selectedCustomSticker) {
				return;
			}
			const sticker = this.selectedCustomSticker;
			switch (item.key) {
				case 'TOP':
					this.setCustomStickerTop(sticker.id);
					break;
				case 'DELETE':
					this.deleteCustomSticker(sticker.id);
					break;
			}
		},
		setCustomStickerTop(id) {
			this.$http({
				url: `/sticker/custom/top/${id}`,
				method: 'put'
			}).then(() => {
				this.$message.success('置顶成功');
				this.customStickerCache = null;
				this.loadCustomStickers();
			}).catch(() => {
				this.$message.error('置顶失败');
			});
		},
		deleteCustomSticker(id) {
			this.$confirm('确定要删除这个自定义表情吗？', '删除表情', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				return this.$http({
					url: `/sticker/custom/delete/${id}`,
					method: 'delete'
				});
			}).then(() => {
				this.$message.success('删除成功');
				this.customStickerCache = null;
				this.loadCustomStickers();
			})
		},
		addCustomSticker(sticker) {
			return this.$http({
				url: '/sticker/custom/add',
				method: 'post',
				data: sticker
			});
		},
		onUploadSuccess(imageData) {
			const sticker = {
				name: '',
				imageUrl: imageData.originUrl,
				thumbUrl: imageData.thumbUrl,
				width: imageData.width || 0,
				height: imageData.height || 0
			};
			this.addCustomSticker(sticker).then(() => {
				this.$message.success('添加成功');
				this.customStickerCache = null;
				this.loadCustomStickers();
			})
		}
	},
	computed: {
		x() {
			return this.pos.x - 22;
		},
		y() {
			return this.pos.y - 294;
		},
		isSearchTab() {
			return this.selectedAlbumId === 'search';
		},
		searchName() {
			return (this.searchText || '').trim();
		},
		defaultEmotions() {
			return this.$emo.emoTextList || [];
		},
		isDefaultTab() {
			return this.selectedAlbumId === 'default';
		},
		isCustomTab() {
			return this.selectedAlbumId === 'custom';
		},
		albumBarItems() {
			const searchItem = [{ id: 'search', name: '搜索表情', isSearch: true }];
			const defaultItem = [{ id: 'default', name: '默认表情', isDefault: true }];
			const customItem = [{ id: 'custom', name: '我的表情', isCustom: true }];
			return searchItem.concat(defaultItem, customItem, this.albumList || []);
		},
		displayAlbumItems() {
			if (!this.isNeedPage) {
				return this.albumBarItems;
			}
			const start = this.albumPage * this.albumsPerPage;
			return this.albumBarItems.slice(start, start + this.albumsPerPage);
		},
		totalAlbumPages() {
			const total = this.albumBarItems.length;
			return total > 0 ? Math.ceil(total / this.albumsPerPage) : 1;
		},
		canPrev() {
			return this.albumPage > 0;
		},
		canNext() {
			return this.albumPage < this.totalAlbumPages - 1;
		},
		isNeedPage() {
			return this.albumBarItems.length > this.albumsPerPage + 1;
		}
	}
}
</script>
<style scoped lang="scss">
// ============================================================
// Emoji 面板 — 标杆深化 (Apple iOS 26 / Liquid Glass)
// 用户反馈: 原本是死白边框面板、默认 emoji 、底部三个灰小图标
// 现: glass-l2 浮层 + 分类 tab Aurora 选中态 + emoji 悬浮高光环 + 底部图标 chip
// ============================================================
.chat-emotion {
	position: fixed;
	width: 432px;
	box-sizing: border-box;
	padding: 12px 12px 8px;
	display: flex;
	flex-direction: column;

	// 真液态玻璃 L2 (§3.1) + Aurora 环境微光
	background:
		radial-gradient(120% 80% at 0% 0%, rgba(255, 230, 130, 0.10) 0%, transparent 55%),
		radial-gradient(100% 60% at 100% 100%, rgba(255, 200, 220, 0.10) 0%, transparent 55%),
		rgba(255, 252, 243, 0.82);
	backdrop-filter: blur(40px) saturate(160%);
	-webkit-backdrop-filter: blur(40px) saturate(160%);
	border: 0.5px solid rgba(255, 255, 255, 0.65);
	border-radius: 20px;
	box-shadow:
		inset 0 1px 0 0 rgba(255, 255, 255, 0.92),
		0 4px 12px rgba(31, 31, 35, 0.06),
		0 24px 64px rgba(31, 31, 35, 0.14);
	animation: emoFloat 240ms cubic-bezier(0.32, 0.72, 0, 1);

	@keyframes emoFloat {
		from { opacity: 0; transform: translateY(8px) scale(0.985); }
		to   { opacity: 1; transform: translateY(0) scale(1); }
	}

	// 顶部 Aurora 微光线 (§4.3 五色)
	&::before {
		content: '';
		position: absolute;
		top: 0; left: 14px; right: 14px;
		height: 1px;
		border-radius: 1px;
		background: linear-gradient(90deg,
			rgba(91,141,238,0) 0%,
			rgba(91,141,238,0.55) 18%,
			rgba(168,139,255,0.65) 38%,
			rgba(255,175,204,0.55) 58%,
			rgba(212,175,106,0.55) 80%,
			rgba(91,141,238,0) 100%);
		opacity: 0.7;
		pointer-events: none;
	}

	.emotion-scroll {
		height: 240px;
		border-radius: 12px;
	}

	.emotion-section {
		padding: 4px 2px 8px;
	}

	.emotion-items {
		display: grid;
		grid-template-columns: repeat(8, 1fr);
		gap: 4px;
		margin-top: 4px;

		.emotion-item {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			border-radius: 10px;
			position: relative;
			padding: 2px;
			transition:
				transform 220ms cubic-bezier(0.32, 0.72, 0, 1),
				background 220ms ease,
				box-shadow 220ms ease;

			&:hover {
				transform: translateY(-1px) scale(1.06);
				background:
					linear-gradient(135deg, rgba(91,141,238,0.16), rgba(168,139,255,0.14) 60%, rgba(255,175,204,0.12));
				box-shadow:
					inset 0 1px 0 0 rgba(255,255,255,0.9),
					0 4px 10px rgba(91, 141, 238, 0.20);
			}
			&:active { transform: scale(0.94); }
		}
	}

	.sticker-items {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-gap: 8px;
		margin-top: 6px;

		.sticker-item {
			width: 100%;
			height: 80px;
			border-radius: 12px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			padding: 6px 4px 6px;
			position: relative;
			border: 0.5px solid transparent;
			transition:
				transform 220ms cubic-bezier(0.32, 0.72, 0, 1),
				background 220ms ease,
				box-shadow 220ms ease,
				border-color 220ms ease;

			img {
				width: 50px;
				height: 50px;
				border-radius: 8px;
				transition: transform 220ms cubic-bezier(0.32, 0.72, 0, 1);
			}

			.sticker-name {
				margin-top: 4px;
				font-size: 11px;
				letter-spacing: 0;
				color: var(--im-text-color-lighter);
				text-align: center;
				width: 100%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			&:hover {
				transform: translateY(-2px);
				background:
					linear-gradient(135deg, rgba(91,141,238,0.12), rgba(168,139,255,0.10) 60%, rgba(255,175,204,0.08));
				border-color: rgba(91, 141, 238, 0.28);
				box-shadow:
					inset 0 1px 0 0 rgba(255,255,255,0.9),
					0 6px 16px rgba(91, 141, 238, 0.18);

				img { transform: scale(1.06); }
			}
			&:active { transform: scale(0.97); }

			&.upload-item {
				background: rgba(255, 255, 255, 0.45);

				.upload-btn {
					width: 50px;
					height: 50px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 12px;
					background:
						linear-gradient(135deg, rgba(91, 141, 238, 0.12), rgba(168, 139, 255, 0.10));
					border: 1px dashed rgba(91, 141, 238, 0.35);
					transition: all 220ms ease;

					i {
						font-size: 24px;
						color: var(--aurora-blue);
						transition: transform 240ms cubic-bezier(0.32, 0.72, 0, 1);
					}
				}
				&:hover .upload-btn i { transform: rotate(90deg) scale(1.1); }
			}
		}
	}

	.sticker-empty {
		text-align: center;
		color: var(--im-text-color-lighter);
		font-size: 12px;
		letter-spacing: -0.1px;
		padding: 28px 0;
		line-height: 1.5;
	}

	.search-box {
		margin-bottom: 10px;
		padding: 0 2px;
	}

	.search-box :deep(.el-input__inner) {
		height: 32px;
		border-radius: 999px !important;
		background: rgba(255, 255, 255, 0.55) !important;
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		border: 0.5px solid var(--hairline-mid) !important;
		padding-right: 30px;
		transition: all 220ms ease;

		&:focus {
			border-color: rgba(91, 141, 238, 0.55) !important;
			box-shadow: 0 0 0 3px rgba(91, 141, 238, 0.14);
			background: rgba(255, 255, 255, 0.78) !important;
		}
	}

	.album-bar-wrapper {
		display: flex;
		align-items: center;
		margin-top: 8px;
		padding-top: 10px;
		padding-bottom: 4px;
		border-top: 0.5px solid var(--hairline-soft);
		gap: 8px;

		.album-arrow {
			width: 28px;
			height: 28px;
			border-radius: 50%;
			border: 0.5px solid var(--hairline-mid);
			background: rgba(255, 255, 255, 0.55);
			backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			display: flex;
			align-items: center;
			justify-content: center;
			color: var(--im-text-color-secondary);
			cursor: pointer;
			transition: all 220ms ease;

			i { font-size: 14px; }

			&:hover:not(:disabled) {
				color: var(--aurora-blue);
				border-color: rgba(91, 141, 238, 0.4);
				background:
					linear-gradient(135deg, rgba(91, 141, 238, 0.16), rgba(168, 139, 255, 0.12));
				transform: translateY(-1px);
				box-shadow: 0 4px 10px rgba(91, 141, 238, 0.16);
			}
			&:active:not(:disabled) { transform: scale(0.94); }

			&:disabled {
				opacity: 0.35;
				cursor: not-allowed;
			}
		}

		.album-bar {
			flex: 1;
			display: flex;
			flex-wrap: nowrap;
			gap: 6px;
			cursor: pointer;

			.album-item {
				flex: 0 0 auto;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 36px;
				height: 36px;
				border-radius: 12px;
				cursor: pointer;
				font-size: 0;
				position: relative;
				border: 0.5px solid transparent;
				transition: all 220ms cubic-bezier(0.32, 0.72, 0, 1);

				img {
					width: 26px;
					height: 26px;
					border-radius: 8px;
					object-fit: cover;
				}

				.album-item-icon {
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 0;
					line-height: 1;
					width: 24px;
					height: 24px;
					color: var(--im-text-color-secondary);
					transition: color 220ms ease;

					i { font-size: 22px; }
				}

				// Aurora 五色 nth 点缀 (§4.3)
				&:nth-child(5n+1):not(.active) .album-item-icon { color: rgba(91, 141, 238, 0.78); }
				&:nth-child(5n+2):not(.active) .album-item-icon { color: rgba(168, 139, 255, 0.78); }
				&:nth-child(5n+3):not(.active) .album-item-icon { color: rgba(212, 175, 106, 0.85); }
				&:nth-child(5n+4):not(.active) .album-item-icon { color: rgba(255, 175, 204, 0.85); }
				&:nth-child(5n+5):not(.active) .album-item-icon { color: rgba(91, 141, 238, 0.78); }

				&.active {
					background:
						linear-gradient(135deg, rgba(91, 141, 238, 0.18), rgba(168, 139, 255, 0.16) 60%, rgba(255, 175, 204, 0.12));
					border-color: rgba(91, 141, 238, 0.4);
					box-shadow:
						inset 0 1px 0 0 rgba(255, 255, 255, 0.9),
						0 2px 8px rgba(91, 141, 238, 0.18);

					.album-item-icon { color: var(--aurora-blue); }
				}

				&:hover:not(.active) {
					background: rgba(91, 141, 238, 0.08);
					transform: translateY(-1px);
				}
				&:active { transform: scale(0.94); }
			}
		}
	}

	.preview-box {
		position: absolute;
		width: 132px;
		height: 132px;
		padding: 8px;
		background: rgba(31, 31, 35, 0.82);
		backdrop-filter: blur(20px) saturate(140%);
		-webkit-backdrop-filter: blur(20px) saturate(140%);
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		pointer-events: none;
		box-shadow:
			inset 0 1px 0 0 rgba(255, 255, 255, 0.18),
			0 12px 32px rgba(0, 0, 0, 0.32);
		border: 0.5px solid rgba(255, 255, 255, 0.18);

		img {
			max-width: 100%;
			max-height: 100%;
			border-radius: 8px;
		}
	}
}
</style>
